<template>
  <div>
    <div :class="{'wrapper mt-3': true, 'is-loading': !loaded}">
      <f-list
        ref="settlements-list"
        class="settlements-list"
        :loaded="loaded"
        :listSettings="settlementsListSettings"
        :listItems="settlementsFormatted"
        :data-mobile-actions-count="0" />
    </div>

    <pagination
      :hasWrapper="true"
      :meta-data="paginationMetaData"
      :elementsCounterLabel="'elements'" />

    <div
      v-if="!loaded && !loadError"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
    <div class="wrapper mt-3">
      <f-alert
        v-if="loadError"
        visible
        theme="warning">
        <span>
          {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
        </span>
      </f-alert>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ListUtils from '@/utils/ListUtils.js';
import CalendarUtils from '@/utils/CalendarUtils.js';
import Pagination from '@/components/core/Pagination.vue';
import HasPagination from '@/mixins/HasPagination.vue';

export default {
  name: 'settlements-list',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    settlementsListSettings () {
      let settingList = [
        {
          title: 'ID',
          variableName: ['id'],
          type: 'String',
          sortable: false
        },
        {
          title: this.$t('settlements.date'),
          variableName: ['date'],
          type: 'String'
        },
        {
          title: this.$t('settlements.type'),
          variableName: ['purchaseName'],
          type: 'String'
        },
        {
          title: this.$t('settlements.amount'),
          variableName: ['purchaseTotal'],
          type: 'String',
          additionalClass: 'text-danger'
        },
        {
          title: this.$t('settlements.invoice'),
          variableName: ['invoiceLink'],
          type: 'external-link',
          icon: 'download',
          linkClass: 'lnk lnk-dark pr-2'
        }
      ];

      return settingList;
    },
    settlementsFormatted () {
      let settlementsList = this.settlements;

      if (!settlementsList.length) {
        return [];
      }

      return settlementsList.map(item => ({
        id: item.id,
        date: this.humanDateFormat(item.sell_date),
        purchaseName: item.items[0].name,
        purchaseTotal: `-${item.total_price} PLN`,
        invoiceLink: {
          url: item.view_url,
          text: this.$t('settlements.download')
        }
      }));
    },
  },
  data() {
    return {
      settlements: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
    }
  },
  mounted() {
    this.$bus.$on('settlements-reload', this.loadItemsData);
    this.loadItemsData();
  },
  methods: {
    loadItemsData () {
      Vue.set(this, 'loaded', false);
      let endpointUrl = '/api/adviser/invoices/items?page=' + this.currentPage;

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: endpointUrl,
        listField: 'settlements',
        pagination: true
      });
    },
    humanDateFormat (inputDate) {
      return CalendarUtils.humanDateFormat(inputDate, false, true);
    },
  },
  beforeDestroy () {
    this.$bus.$off('settlements-reload', this.loadItemsData);
  }
}
</script>
